/**
 * 日期格式化
 * @param time
 * @returns {string}
 */
function dateFormat (time) {
  if (!time) {
    return ''
  }
  var date = new Date(time)
  var year = date.getFullYear()
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  // 拼接
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}
/*
 * 隐藏用户手机号中间四位
 */
export function hidePhone (phone) {
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}
/*
 * 隐藏用户身份证中间
 */
export function hideSfzmhm (sfzmhm) {
  return (sfzmhm && sfzmhm.length === 18) ? sfzmhm.replace(/(\d)\d{16}(\w)/, '$1****************$2') : sfzmhm
}
/*
 * 隐藏用户名
 */
export function hideXm (name) {
  if (name.length === 2) { return name.replace(/^./, '*') }// 三个字的姓名，隐藏第一个字
  else if (name.length === 3) { return name.replace(/^./, '*') }// 六个字以下，三个字以上，只显示最后两个字
  else if (name.length <= 6 && name.length >= 3) {
    return name.replace(name.substr(0, name.length - 2), '***')
  } else {
    return name.replace(/^./, '*')
  }
}
export {
  dateFormat
}



// WEBPACK FOOTER //
// ./src/filters/baseFilter.js